// src/lib/feature-flags.ts
//
// Feature flags genéricos del frontend. Se controlan vía variables de entorno
// NEXT_PUBLIC_* (visibles en el navegador). Agregar aquí los flags de dominio
// (ligas, equipos, etc.) cuando existan.
//
// NOTA: no hay flags de cobros/suscripciones — esa fase no está implementada.

/** Habilita el registro de nuevos usuarios. Por defecto activado. */
export const isRegistrationEnabled =
  process.env.NEXT_PUBLIC_ENABLE_REGISTRATION !== "false";

/**
 * Habilita la landing de marketing en la home (`/{locale}`). Por defecto activado.
 * Si se desactiva, la home redirige a `/login` (ver `(marketing)/page.tsx`).
 */
export const isLandingEnabled =
  process.env.NEXT_PUBLIC_ENABLE_LANDING !== "false";

/** Habilita el tracking de analytics públicos (landing). Por defecto activado. */
export const isPublicAnalyticsEnabled =
  process.env.NEXT_PUBLIC_ENABLE_PUBLIC_ANALYTICS !== "false";

/**
 * Kill-switch de Google Sign-In (OAuth via Hosted UI + PKCE).
 * Default DESACTIVADO (opt-in): solo se habilita si la env var vale exactamente "true".
 */
export const isGoogleAuthEnabled =
  process.env.NEXT_PUBLIC_ENABLE_GOOGLE_AUTH === "true";
